import '../index.scss';

export const RibbonMenuSeparator = () => {
  return <div className="RibbonMenuSeparator" />;
};
